module.exports = __webpack_public_path__ + "static/open_fct2-f0f46b047078811ac47f5c34bb89bd04.jpg";